export default __webpack_public_path__ + "static/media/img_09.4871b8a3.jpg";